import { take, call, put, fork, cancel } from 'redux-saga/effects'

import { setLeaderboard } from '../../features/leaderboard/leaderboardSlice'
import { RequestLeaderboard } from '../requests/requestLeaderboard'

export function queryLeaderboard() {
  return new Promise(async (resolve, reject) => {
    try {
      const collection = await RequestLeaderboard()
      resolve(collection)
    } catch (error) {
      reject(error)
    }
  })
}

export function* resolveLeaderboard() {
  try {
    const leaderboardData = yield call(queryLeaderboard)
    console.log(leaderboardData)
    const { data } = yield leaderboardData

    const getLeaderboard = () => {
      if (Object.keys(data).length > 0) {
        try {
          const result = JSON.parse(JSON.stringify(data.message))
          return result
        } catch (error) {
          console.error(error)
        }
      } else {
        return 'No Data from the Server'
      }
    }

    const leaderboard = yield getLeaderboard()
    if (leaderboard === 'No Data from the Server') {
      yield put(
        setLeaderboard({
          type: 'GET_LEADERBOARD_ERROR',
          leaderboard,
        }),
      )
    } else {
      yield put(
        setLeaderboard({
          type: 'GET_LEADERBOARD_SUCCESS',
          leaderboard,
        }),
      )
    }
  } catch (error) {
    const errorMsg = error.toString()
    yield put(
      setLeaderboard({ type: 'GET_LEADERBOARD_ERROR', error: errorMsg }),
    )
  }
}

export function* LeaderboardFlow() {
  while (true) {
    yield put(setLeaderboard({ type: 'GET_LEADERBOARD_START' }))
    const task = yield fork(resolveLeaderboard)
    const action = yield take(['GET_LEADERBOARD_ERROR'])
    if (action.type === 'GET_LEADERBOARD_ERROR') {
      yield cancel(task)
    }
  }
}
